/**
 * Enum des fonctionnalités disponibles dans l'application
 * Doit correspondre exactement à l'enum backend
 */
export const PlanFeature = {
  // Fonctionnalités principales
  CODE_GENERATION: "code_generation", // Génération de code Silae
  VARIABLE_LIBRARY: "variable_library", // Bibliothèque de variables
  CODE_EDITOR: "code_editor", // Éditeur de code

  // Fonctionnalités avancées (pour plans premium)
  EXPORT_FUNCTIONALITY: "export_functionality", // Fonctionnalités d'export
  AI_SILAE: "ai_silae", // Génération IA SILAE
} as const;

/**
 * Configuration des fonctionnalités avec leurs métadonnées
 */
export interface FeatureConfig {
  id: string;
  name: string;
  description: string;
  icon: string;
  category: "core" | "premium";
  isDefault: boolean; // Fonctionnalité incluse par défaut dans tous les plans
}

/**
 * Configuration complète de toutes les fonctionnalités
 */
export const FEATURE_CONFIGS: Record<string, FeatureConfig> = {
  [PlanFeature.CODE_GENERATION]: {
    id: PlanFeature.CODE_GENERATION,
    name: "Génération de code",
    description: "Générateur intelligent de code Silae",
    icon: "Code2",
    category: "core",
    isDefault: true,
  },
  [PlanFeature.VARIABLE_LIBRARY]: {
    id: PlanFeature.VARIABLE_LIBRARY,
    name: "Bibliothèque de variables",
    description: "Accès à la bibliothèque complète des variables Silae",
    icon: "LibraryBig",
    category: "core",
    isDefault: false,
  },
  [PlanFeature.CODE_EDITOR]: {
    id: PlanFeature.CODE_EDITOR,
    name: "Éditeur de code",
    description: "Éditeur de code avancé avec syntax highlighting",
    icon: "AppWindowMac",
    category: "core",
    isDefault: false,
  },
  [PlanFeature.EXPORT_FUNCTIONALITY]: {
    id: PlanFeature.EXPORT_FUNCTIONALITY,
    name: "Fonctionnalités d'export",
    description: "Export avancé en différents formats",
    icon: "Download",
    category: "premium",
    isDefault: false,
  },
  [PlanFeature.AI_SILAE]: {
    id: PlanFeature.AI_SILAE,
    name: "Génération IA SILAE",
    description: "Génération de code SILAE assistée par IA avec base de connaissances",
    icon: "Brain",
    category: "premium",
    isDefault: false,
  },
};

/**
 * Obtenir la configuration d'une fonctionnalité
 */
export function getFeatureConfig(featureId: string): FeatureConfig {
  return FEATURE_CONFIGS[featureId];
}

/**
 * Obtenir toutes les fonctionnalités par catégorie
 */
export function getFeaturesByCategory(
  category: "core" | "premium",
): FeatureConfig[] {
  return Object.values(FEATURE_CONFIGS).filter(
    (config) => config.category === category,
  );
}

/**
 * Obtenir les fonctionnalités par défaut
 */
export function getDefaultFeatures(): FeatureConfig[] {
  return Object.values(FEATURE_CONFIGS).filter((config) => config.isDefault);
}
